import type { LucideIcon } from 'lucide-react'
import { Inbox } from 'lucide-react'
import type { ReactNode } from 'react'

interface Props {
  title: string
  message?: string
  icon?: LucideIcon
  action?: ReactNode
}

export function EmptyState({ title, message, icon: Icon = Inbox, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-slate-200 bg-white px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400">
        <Icon size={26} />
      </div>
      <h3 className="text-headline-sm font-semibold text-slate-800">{title}</h3>
      {message && <p className="max-w-md text-body-sm text-slate-500">{message}</p>}
      {action}
    </div>
  )
}
